import React, {useEffect, useRef, useState} from "react";
import classnames from "classnames";
import ObserversService from "../../../../../../../core/services/observers";
import {ChevronLeft, ChevronRight, Clear} from "@mui/icons-material";
import IconButton from "../../../../../../components/base/button/icon_button";

const CompareViewProductChips = ({
                                     products,
                                     selectedProductId,
                                     selectProduct,
                                     removeProduct,
                                 }) => {
    const [showButtons, setShowButtons] = useState(false);
    /**@type {React.MutableRefObject<HTMLDivElement>}*/
    const layoutRef = useRef();
    /**@type {React.MutableRefObject<HTMLDivElement>}*/
    const innerLayoutRef = useRef();

    /**
     * As soon as the component mounts:
     * - attaches an observer that would determine whether the scroll buttons should be shown or not based on the width of the chips and
     * their container.
     */
    useEffect(() => {
        const parent = layoutRef.current?.parentElement;
        if (!parent)
            return;
        const observer = ObserversService.newResizeObserver((entries) => {
            // 39 is the padding of the parent element.
            setShowButtons(((entries?.[0]?.contentRect?.width ?? 0) - 39) < (innerLayoutRef.current?.scrollWidth ?? 0));
        })
        setShowButtons((parent?.getBoundingClientRect()?.width ?? 0) < (innerLayoutRef.current?.scrollWidth ?? 0));
        ObserversService.observeResizeObserver(observer, parent);
        return () => {
            ObserversService.disconnectResizeObserver(observer);
        }
    }, [products?.length])

    /**
     * Handles removing a product from the list of items in compare screen:
     * - Shows a confirmation dialog from for user
     * - after confirmation, calls the function regarding this action
     *
     * @param {MouseEvent<HTMLButtonElement>} e
     * @param {Object}  product
     */
    const getRemoveProductConfirmation = (e, product) => {
        e.stopPropagation();
        e.preventDefault();
        window.partner?.openConfirmationDialog(
            <div className={'p-3'}>
                <p className={'text-sm text-color-2'}>
                    Do you want to remove the selected product from compare list?
                </p>
            </div>,
            {
                maxWidth: 'sm'
            },
            (confirmed) => confirmed && _remove(product),
        );
    }

    const _remove = (product) => {
        removeProduct(product).then();
    }

    /**
     * Scrolls the content of the product chips.
     * @param forward
     */
    const scroll = (forward = false) => {
        innerLayoutRef.current.scrollBy({left: (layoutRef.current.getBoundingClientRect().width ?? 0) * (forward ? 1 : -1), top: 0});
    }

    return (
        <>
            <div className={'product-chips-list-container'} ref={layoutRef}>
                {
                    showButtons &&
                    <IconButton
                        className={'back-button prev'}
                        color={"secondary"}
                        onPressed={() => scroll(false)}
                    >
                        <ChevronLeft/>
                    </IconButton>
                }
                <div className={'product-chips-list'} ref={innerLayoutRef}>
                    {
                        products.map((product) => (
                            <div
                                key={product?.id}
                                className={classnames(
                                    'product-chips',
                                    {'selected': product.id === selectedProductId}
                                )}
                                onClick={() => selectProduct(product)}
                            >
                                <p className={'mb-0'}>{product?.partNo ?? ""}</p>
                                <IconButton
                                    className={'remove-icon-button'}
                                    onPressed={(e) => getRemoveProductConfirmation(e, product)}
                                    color={'secondary'}
                                >
                                    <Clear className={'icon large'}/>
                                </IconButton>
                            </div>
                        ))
                    }
                </div>
                {
                    showButtons &&

                    <IconButton
                        className={'back-button next'}
                        color={"secondary"}
                        onPressed={() => scroll(true)}
                    >
                        <ChevronRight/>
                    </IconButton>
                }
            </div>
        </>
    )
}

export default CompareViewProductChips;
